import React from "react";
import { tags } from "./resource.tags.data";
import "./resource-tags.styles.scss";

function ResourceTags() {
  return (
    <div className="tags-container">
      <ul>
        {tags.map((tag) => (
          <>
            <li className={`list-item-${tag.color} list-item`} key={tag.id}>
              {tag.name}
            </li>
            {/* <span className="bar-seperator">|</span> */}
          </>
        ))}
      </ul>
    </div>
  );
}

export default ResourceTags;
